import styles from "./index.module.scss";
import { Input, Select, message } from "antd";
import { useState, useContext, useEffect, useRef } from "react";
import SelectBtnGroups from "@view/page_v3/components/SelectBtnGroups";
import { ProjectContext } from "../../../hooks/ProjectContext";
import Iconfont from "@utils/Iconfont";
import { AppContext } from "@utils/AppContext";
import API from "@api/api.js";
import { IMAGE_TYPE } from "@utils/CONST";

const ProListpageTop = (props) => {
    const {
        setProOrder,
        setProSortField,
        proFunction,
        setProFunction,
        projectName,
        setProjectName,
    } = useContext(ProjectContext);
    const { proSidebarValue, globalOrgInfo } = useContext(AppContext);
    const [memberList, setMemberList] = useState([]);
    const [searchValue, setSearchValue] = useState(projectName || "");
    const isComposingRef = useRef(false);

    const getListOrgMember = () => {
        API.getListOrgMember({}).then((res) => {
            if (res.code !== 0) return message.error(res.msg);
            const list = res.data
                .filter((item) => item.role != "admin")
                .map((item) => ({
                    value: item.userId,
                    label: item.deleted
                        ? item.orgNickname + "（已移除）"
                        : item.orgNickname,
                }));
            setMemberList(list);
        });
    };
    const memberChange = (value) => {
        props.setMember(value || "team");
    };

    useEffect(() => {
        getListOrgMember();
    }, []);

    useEffect(() => {
        setSearchValue(projectName || "");
    }, [projectName]);

    useEffect(() => {
        if (isComposingRef.current) return;
        const timer = setTimeout(() => {
            setProjectName(searchValue);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchValue, setProjectName]);

    const sortChange = (value) => {
        if (value == "updatedTimeAsc") {
            setProSortField("updatedTime");
            setProOrder("asc");
        } else if (value == "updatedTimeDesc") {
            setProSortField("updatedTime");
            setProOrder("desc");
        } else if (value == "projectNameAsc") {
            setProSortField("projectName");
            setProOrder("asc");
        } else if (value == "projectNameDesc") {
            setProSortField("projectName");
            setProOrder("desc");
        }
    };

    const typeOptions = {
        model: [
            { value: "", label: <span>全部项目类型</span> },
            { value: "clothes", label: <span>AI试衣图</span> },
            { value: "simTryon", label: <span>同版型试衣</span> },
            { value: IMAGE_TYPE.FLATLAY3D, label: <span>平铺转3D</span> },
            { value: "model", label: <span>换模特图</span> },
            { value: "modelChangeBkg", label: <span>换背景</span> },
            { value: "shoesTryon", label: <span>鞋子上脚</span> },
            { value: "glassesTryon", label: <span>眼镜试戴</span> },
            { value: "jewelryTryon", label: <span>项链试戴</span> },
            { value: "poseFantasy", label: <span>姿势裂变</span> },
            { value: "clothRecolor", label: <span>服饰换色</span> },
            { value: "fusionWear", label: <span>搭配上身</span> },
            { value: "grassPlant", label: <span>种草图</span> },
            // { value: "smartDetailPage", label: <span>服装详情页</span> },
            { value: "commodity", label: <span>商品换背</span> },
            { value: "commodityRecolor", label: <span>商品换色</span> },
            { value: "watermarkRemove", label: <span>去水印</span> },
        ],
        commodity: [
            { value: "", label: <span>全部项目类型</span> },
            { value: "commodity", label: <span>商品换背</span> },
            { value: "commodityRecolor", label: <span>商品换色</span> },
        ],
        modelVideo: [
            { value: "", label: <span>全部项目类型</span> },
            { value: "tryonVideo", label: <span>动作模仿</span> },
            { value: "image2Video", label: <span>图生视频</span> },
        ],
        aiEdit: [
            { value: "", label: <span>全部项目类型</span> },
            { value: "aiImageExtraction", label: <span>智能抠图</span> },
            { value: "imageResize", label: <span>高清改尺寸</span> },
            { value: "imageFiner", label: <span>AI超清</span> },
            { value: "aibeauty", label: <span>智能补光</span> },
            { value: "removeInpaint", label: <span>魔法擦除</span> },
            { value: "handFix", label: <span>手部修复</span> },
        ],
    };

    const proFunctionChange = (value) => {
        setProFunction(value);
    };

    const hideTypeSelect = proSidebarValue === IMAGE_TYPE.CREATIVE_IMAGE_GEN;

    const commitSearch = (value) => {
        setSearchValue(value);
        setProjectName(value);
    };

    return (
        <div className={styles.ProListpageTop}>
            <div>
                <Select
                    onChange={sortChange}
                    style={{ width: 160, marginRight: "8px" }}
                    defaultValue={"updatedTimeDesc"}
                    options={[
                        {
                            value: "updatedTimeDesc",
                            label: <span>最新修改</span>,
                        },
                        {
                            value: "updatedTimeAsc",
                            label: <span>最早修改</span>,
                        },
                        {
                            value: "projectNameAsc",
                            label: <span>名称正序 A-Z</span>,
                        },
                        {
                            value: "projectNameDesc",
                            label: <span>名称倒序 Z-A</span>,
                        },
                    ]}
                />
                {!hideTypeSelect &&
                    <Select
                        onChange={proFunctionChange}
                        style={{ width: 160, marginRight: "8px" }}
                        value={proFunction}
                        options={typeOptions[proSidebarValue]}
                    />
                }
                {globalOrgInfo?.current?.role == "admin" &&
                    props.tabKey == "2" && (
                        <Select
                            style={{ width: 200, marginRight: "8px" }}
                            allowClear
                            member={props.member}
                            onChange={memberChange}
                            placeholder="请选择成员"
                            options={memberList}
                        />
                    )}
                <Input
                    allowClear
                    value={searchValue}
                    className={styles.focused}
                    placeholder="请搜索项目名称"
                    suffix={
                        <Iconfont
                            type="icon-SearchOutlined"
                            style={{ fontSize: 16, color: "#5b6673" }}
                        />
                    }
                    onChange={(e) => setSearchValue(e.target.value)}
                    onPressEnter={(e) => commitSearch(e.target.value)}
                    onCompositionStart={() => {
                        isComposingRef.current = true;
                    }}
                    onCompositionEnd={(e) => {
                        isComposingRef.current = false;
                        commitSearch(e.currentTarget.value);
                    }}
                />
            </div>
            <SelectBtnGroups
                getIsSelected={props.getIsSelected}
                setSelectedList={props.setSelectedList}
                selectedList={props.selectedList}
                isSelectedAll={props.isSelectedAll}
                downLoading={props.downLoading}
                selectAll={props.selectAll}
                deleteClick={props.deleteClick}
                downClick={props.downClick}
            />
        </div>
    );
};

export default ProListpageTop;
